
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useGlobalStore } from '@/stores/global';
import { useAlertStore } from '@/features/alert-system/stores/alert';
import { Bell, User, Sun, Moon, Activity } from 'lucide-react';

export const Header = () => {
  const { user, darkMode, toggleDarkMode } = useGlobalStore();
  const { unacknowledgedCount, criticalCount } = useAlertStore();

  return (
    <header className="h-16 border-b border-primary/20 tech-card rounded-none shadow-lg">
      {/* 科技感背景效果 */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-primary/5 opacity-50"></div>
      
      <div className="h-full px-6 flex items-center justify-between relative z-10">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-2">
              <Activity className="h-6 w-6 text-primary pulse-glow" />
              <h1 className="text-xl font-bold bg-gradient-to-r from-primary to-cyan-400 bg-clip-text text-transparent">
                船舶数字孪生监控系统
              </h1>
            </div>
            {/* <div className="tech-badge">
              数字孪生平台 v2.1.0
            </div> */}
          </div>
        </div>

        {/* <div className="flex items-center space-x-4">
        
          <div className="relative">
            <Button variant="ghost" size="sm" className="tech-button relative">
              <Bell className="h-4 w-4" />
              {unacknowledgedCount > 0 && (
                <div className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-destructive text-destructive-foreground text-xs flex items-center justify-center pulse-glow">
                  {criticalCount > 0 ? criticalCount : unacknowledgedCount}
                </div>
              )}
            </Button>
          </div>

        
          <Button
            variant="ghost"
            size="sm"
            onClick={toggleDarkMode}
            className="tech-button"
          >
            {darkMode ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </Button>

         
          <div className="flex items-center space-x-2">
            <Button variant="ghost" size="sm" className="tech-button">
              <User className="h-4 w-4" />
              <span className="ml-2 text-sm font-medium">
                {user?.name || '系统管理员'}
              </span>
            </Button>
          </div>
        </div> */}
      </div>
    </header>
  );
};
